export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Grupo', field: 'role_name', sortable: false },
  { name: 'Email', field: 'email', sortable: false },
  { name: 'Usuário', field: 'username', sortable: false },
  { name: 'Ativo', field: 'active', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
